export class ProcoItem {
  id: string;
  // default weight is 3
  weight: number = 3;
  description: string;
  sortOrder: number;
}
